import { all, fork, put, takeLatest, call, takeEvery } from 'redux-saga/effects';
import {
    getTotalChargeAmount as getTotalChargeAmountApi,
    getTotalAuditableAmount as getTotalAuditableAmountApi,
    getAvgTotalChargeAmount as getAvgTotalChargeAmountApi,
    getTotalCostByWeightAndZone as getTotalCostByWeightAndZoneApi,
    getComparisonTotalChargeAmount as getComparisonTotalChargeAmountApi,
    getComparisonAvgTotalChargeAmount as getComparisonAvgTotalChargeAmountApi,
} from '../../helpers';
import { totalCostOptimizationsApiResponseSuccess, totalCostOptimizationsApiResponseError, } from './actions';
import { TotalCostOptimizationsActionTypes } from './constants';
import { totalCostByWeightAndZoneResponseToTotalCostByWeightAndZoneObject } from '../../helpers/mappers/totalCostByWeightAndZone';
import { addToast } from '../actions';

function* getTotalChargeAmount({ payload: { query } }) {
    try {
        const getTotalChargeAmountResponse = yield call(getTotalChargeAmountApi, query);
        yield put(totalCostOptimizationsApiResponseSuccess(TotalCostOptimizationsActionTypes.GET_TOTAL_CHARGE_AMOUNT, getTotalChargeAmountResponse.data));
    } catch (error) {
        yield put(addToast({ desc: error.errors[0].message, type: 'error' }));
        yield put(totalCostOptimizationsApiResponseError(TotalCostOptimizationsActionTypes.GET_TOTAL_CHARGE_AMOUNT, error));
    }
}

function* getTotalAuditableAmount({ payload: { query } }) {
    try {
        const getTotalAuditableAmountResponse = yield call(getTotalAuditableAmountApi, query);
        yield put(totalCostOptimizationsApiResponseSuccess(TotalCostOptimizationsActionTypes.GET_TOTAL_AUDITABLE_AMOUNT, getTotalAuditableAmountResponse.data));
    } catch (error) {
        yield put(addToast({ desc: error.errors[0].message, type: 'error' }));
        yield put(totalCostOptimizationsApiResponseError(TotalCostOptimizationsActionTypes.GET_TOTAL_AUDITABLE_AMOUNT, error));
    }
}

function* getAvgTotalChargeAmount({ payload: { query } }) {
    try {
        const getAvgTotalChargeAmountResponse = yield call(getAvgTotalChargeAmountApi, query);
        yield put(totalCostOptimizationsApiResponseSuccess(TotalCostOptimizationsActionTypes.GET_AVG_TOTAL_CHARGE_AMOUNT, getAvgTotalChargeAmountResponse.data));
    } catch (error) {
        yield put(addToast({ desc: error.errors[0].message, type: 'error' }));
        yield put(totalCostOptimizationsApiResponseError(TotalCostOptimizationsActionTypes.GET_AVG_TOTAL_CHARGE_AMOUNT, error));
    }
}

function* getComparisonTotalChargeAmount({ payload: { query } }) {
    try {
        const getComparisonTotalChargeAmountResponse = yield call(getComparisonTotalChargeAmountApi, query);
        yield put(totalCostOptimizationsApiResponseSuccess(TotalCostOptimizationsActionTypes.GET_COMPARISON_TOTAL_CHARGE_AMOUNT, getComparisonTotalChargeAmountResponse.data));
    } catch (error) {
        yield put(addToast({ desc: error.errors[0].message, type: 'error' }));
        yield put(totalCostOptimizationsApiResponseError(TotalCostOptimizationsActionTypes.GET_COMPARISON_TOTAL_CHARGE_AMOUNT, error));
    }
}

function* getComparisonAvgTotalChargeAmount({ payload: { query } }) {
    try {
        const getComparisonAvgTotalChargeAmountResponse = yield call(getComparisonAvgTotalChargeAmountApi, query);
        yield put(totalCostOptimizationsApiResponseSuccess(TotalCostOptimizationsActionTypes.GET_COMPARISON_AVG_TOTAL_CHARGE_AMOUNT, getComparisonAvgTotalChargeAmountResponse.data));
    } catch (error) {
        yield put(addToast({ desc: error.errors[0].message, type: 'error' }));
        yield put(totalCostOptimizationsApiResponseError(TotalCostOptimizationsActionTypes.GET_COMPARISON_AVG_TOTAL_CHARGE_AMOUNT, error));
    }
}

function* getTotalCostByWeightAndZone({ payload: { query } }) {
    try {
        const getTotalCostByWeightAndZoneResponse = yield call(getTotalCostByWeightAndZoneApi, query);
        const totalCostByWeightAndZone = getTotalCostByWeightAndZoneResponse.data.map((totalCostByWeightAndZoneResponse) =>
            totalCostByWeightAndZoneResponseToTotalCostByWeightAndZoneObject(totalCostByWeightAndZoneResponse)
        );
        yield put(totalCostOptimizationsApiResponseSuccess(TotalCostOptimizationsActionTypes.GET_TOTAL_COST_BY_WEIGHT_AND_ZONE, totalCostByWeightAndZone));
    } catch (error) {
        yield put(addToast({ desc: error.errors[0].message, type: 'error' }));
        yield put(totalCostOptimizationsApiResponseError(TotalCostOptimizationsActionTypes.GET_TOTAL_COST_BY_WEIGHT_AND_ZONE, error));
    }
}

export function* watchGetTotalChargeAmount(): any {
    yield takeLatest(TotalCostOptimizationsActionTypes.GET_TOTAL_CHARGE_AMOUNT, getTotalChargeAmount);
}

export function* watchGetTotalAuditableAmount(): any {
    yield takeLatest(TotalCostOptimizationsActionTypes.GET_TOTAL_AUDITABLE_AMOUNT, getTotalAuditableAmount);
}

export function* watchGetAvgTotalChargeAmount(): any {
    yield takeLatest(TotalCostOptimizationsActionTypes.GET_AVG_TOTAL_CHARGE_AMOUNT, getAvgTotalChargeAmount);
}

export function* watchGetComparisonTotalChargeAmount(): any {
    yield takeLatest(TotalCostOptimizationsActionTypes.GET_COMPARISON_TOTAL_CHARGE_AMOUNT, getComparisonTotalChargeAmount);
}

export function* watchGetComparisonAvgTotalChargeAmount(): any {
    yield takeLatest(TotalCostOptimizationsActionTypes.GET_COMPARISON_AVG_TOTAL_CHARGE_AMOUNT, getComparisonAvgTotalChargeAmount);
}

export function* watchGetTotalCostByWeightAndZone(): any {
    yield takeLatest(TotalCostOptimizationsActionTypes.GET_TOTAL_COST_BY_WEIGHT_AND_ZONE, getTotalCostByWeightAndZone);
}

function* totalCostOptimizationsSaga() {
    yield all([
        fork(watchGetTotalChargeAmount),
        fork(watchGetTotalAuditableAmount),
        fork(watchGetAvgTotalChargeAmount),
        fork(watchGetComparisonTotalChargeAmount),
        fork(watchGetComparisonAvgTotalChargeAmount),
        fork(watchGetTotalCostByWeightAndZone),
    ]);
}

export default totalCostOptimizationsSaga;
